export const formatEUR = (v) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(Number(v) || 0);

export const statusColor = (status) => {
  switch (status) {
    case "Conclusa":
      return "text-emerald-400 border-emerald-400/30 bg-emerald-400/10";
    case "In corso":
      return "text-amber-400 border-amber-400/30 bg-amber-400/10";
    case "In arrivo":
      return "text-sky-400 border-sky-400/30 bg-sky-400/10";
    default:
      return "text-zinc-400 border-zinc-400/30 bg-zinc-400/10";
  }
};

export const statusDot = (status) => {
  switch (status) {
    case "Conclusa":
      return "bg-emerald-400";
    case "In corso":
      return "bg-amber-400";
    case "In arrivo":
      return "bg-sky-400";
    default:
      return "bg-zinc-400";
  }
};
